// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import { AppIcon } from '@loa/ui-components';

interface HeaderProps {
  providerName?: string;
  userName?: string;
  userRole?: string;
}

export function Header({ providerName, userName, userRole }: HeaderProps) {
  const displayName = userName ?? 'Provider User';
  const displayRole = userRole ?? 'Provider';
  const initials = displayName
    .split(' ')
    .map((n) => n.charAt(0))
    .join('')
    .slice(0, 2)
    .toUpperCase();
  return (
    <header
      className="flex items-center justify-between bg-[var(--color-surface)] shrink-0"
      style={{
        height: 'var(--header-height)',
        paddingLeft: 'var(--space-xl)',
        paddingRight: 'var(--space-xl)',
        borderBottom: '1px solid var(--color-border)',
      }}
    >
      {/* Left: Page title area */}
      <div className="flex items-center gap-4">
        {providerName && (
          <span
            className="font-medium"
            style={{ fontSize: 'var(--font-size-body-02)', color: 'var(--color-text-primary)' }}
          >
            {providerName}
          </span>
        )}
      </div>

      {/* Right: Notifications + User */}
      <div className="flex items-center" style={{ gap: 'var(--space-xl)' }}>
        {/* Notification Bell */}
        <button
          className="flex items-center justify-center rounded-full bg-[var(--color-primary-light)] relative"
          style={{ width: 'var(--control-size)', height: 'var(--control-size)' }}
        >
          <AppIcon name="bell" size={24} color="#2D0A6C" variant="Linear" />
        </button>

        {/* User Info */}
        <div className="flex items-center" style={{ gap: '11px' }}>
          <div
            className="rounded-full bg-[var(--color-primary-light)] flex items-center justify-center"
            style={{ width: 'var(--avatar-size)', height: 'var(--avatar-size)' }}
          >
            <span
              className="font-semibold"
              style={{ fontSize: 'var(--font-size-body-03)', color: 'var(--color-primary)' }}
            >
              {initials}
            </span>
          </div>
          <div className="flex flex-col gap-0.5 hidden sm:flex">
            <span
              className="font-medium"
              style={{ fontSize: 'var(--font-size-body-02)', color: 'var(--color-text-primary)' }}
            >
              {displayName}
            </span>
            <span style={{ fontSize: 'var(--font-size-body-03)', color: 'var(--color-text-tertiary)' }}>
              {displayRole}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
